import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed } from 'vue';

import { TitleDetail } from '@/interfaces/title-details-graphql';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import TitleCreditName from '@/components/details/TitleCreditName.vue';
import TitleCreditsPortrait from '@/components/details/TitleCreditsPortrait.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleCredits',
  props: {
    title: null,
    role: { default: '' }
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail, role: string };



const credits = computed(() => {
	if (props.title.__typename === 'Season') {
		return props.title.show?.content.credits ?? [];
	}
	return props.title.content.credits ?? [];
});

const filteredCredits = computed(() => {
	if (!props.role) {
		return credits.value;
	}
	return credits.value.filter(credit => credit.role === props.role);
});

return { __sfc: true,props, credits, filteredCredits, HiddenHorizontalScrollbar, TitleCreditName, TitleCreditsPortrait }
}

})